var URI = {
	init: function() {
		var wh = window.location.href;
		var ac = wh.split('#/');
		this.homeLoadingAnim = $('#content').html();

		if (typeof ac[1] === 'undefined') {
			var no = wh.split('/');
			if (!no[3]) {
				var no = no[3].split('?');
				if (no[0] != 'noticia') {
					window.location.href = '#/home';
				}
			}
		} else {
			URI.exec(ac[1]);
			URI.selectMenu(ac[1]);
			// URI.changeAdCat(ac[1]);
		}
	},
	changeAdCat: function(ac) {
		ac.includes('imprensa/noticias') ? (ac = 'noticias') : (ac = ac);
		ac.includes('imprensa/coberturas') ? (ac = 'coberturas') : (ac = ac);
		$('.an-categoria').val(ac);
		if (typeof adManager !== 'undefined') {
			adManager.update();
		}
	},
	change: function() {
		var wh = window.location.href;
		var ac = wh.split('#/');

		var dd = ac[1].split('/');

		if (typeof ac[1] !== 'undefined') {
			URI.selectMenu(ac[1]);
			URI.exec(ac[1]);
			// URI.changeAdCat(ac[1]);
		}
		$('document').trigger('URIchanged');
	},
	checkAnimation: function(ac = null, selector = null) {
		if (ac === 'home') {
			selector.attr('home-load', 1);
		}
		if (selector.attr('home-load', 1)) {
			selector.attr('home-load', 0);
			selector.html(this.homeLoadingAnim);
		}
		if (ac != 'home') {
			selector.html('').addClass('p5-content-loading');
		}
	},
	exec: function(ac: any = null, title: any = null) {
		let selector = $('#content');
		URI.checkAnimation(ac, selector);

		// setTimeout(function() {
		$.post('/load', { action: ac }, function(r) {
			selector.html(r).removeClass('p5-content-loading');
		});
		// }, 50000);
	},
	selectMenu: function(ac: any) {
		var ac = ac.split('/');
		ac = ac[0];

		// setInterval necessário para correção de bug de renderização.
		// o tamanho do menu só é correto quando a renderização é completada,
		// por isso, checar a cada 100 milisegundos para confirmar se está completa e só assim executar o código

		let check = setInterval(function() {
			if (document.readyState == 'complete') {
				$('.m-n-link').each(function() {
					$(this).removeClass('active');
					let ref = $(this).attr('ref').split('/');
					if (ref.indexOf(`${ac}`) >= 0) {
						$(this).addClass('active');
						$('.m-n-underbar').css('width', $(this).width() / 2);
						let divideby = $(this).width() <= '80' ? $(this).width() / 2 : $(this).width() / 3;
						let calc = $(this).position().left + divideby;
						$('.m-n-underbar').css('left', calc);
					}
				});
				clearInterval(check);
			}
		}, 100);
	}
};

window.onhashchange = function() {
	URI.change();
};
